export default __webpack_public_path__ + "static/hero_cloud_top-d963ae9ee539ae7cc370f55087fdf5b4.webp";